let language = {
    PRODUCT_SERVICE:"产品价格：",
    PRICE_BREAKDOWN: "价格明细",
    PRODUCT_COST: "产品成本：",
    PRODUCT_PICKING_FEE: "Product Picking Fee:",
    PACK_IN_FULFILMENT: "Pack-in Fulfilment:",
    PACKAGING_MATERIALS: "产品物料：",
    PRICE_BREAKDOWN_TIP: "*提供{{appName}}产品价格细目是为了确保所有合作伙伴完全透明。"
};

export { language }